export default __webpack_public_path__ + "static/media/debate_7.2ce9a3d0.JPG";